const ORDERS_KEY = "aio_orders_v1";

const getOrderKey = () => {
  const mobileNo = localStorage.getItem("userMobileNumber") || "guest";
  return `${ORDERS_KEY}_${String(mobileNo).replace(/\D/g, "")}`;
};

const sanitize = (t) =>
  String(t ?? "")
    .replace(/₹/g, "Rs. ")
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[–—]/g, "-")
    .replace(/\s+/g, " ")
    .trim();

export const saveOrder = (order) => {
  try {
    const key = getOrderKey();
    const list = JSON.parse(localStorage.getItem(key) || "[]");
    if (!Array.isArray(list)) return;
    list.unshift(order);
    localStorage.setItem(key, JSON.stringify(list.slice(0, 100)));
  } catch (e) {
    console.warn("saveOrder failed:", e?.message);
  }
};

export const getOrders = () => {
  try {
    const key = getOrderKey();
    const list = JSON.parse(localStorage.getItem(key) || "[]");
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

export const createOrderRecord = ({ orderId, items = [], total = 0, walletBalanceAfter = 0 }) => {
  const date = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  const mobileNo = localStorage.getItem("userMobileNumber");
  const profileStr = localStorage.getItem(`aio_profile_${String(mobileNo || "").replace(/\D/g, "")}`);
  let customerName = "";
  let customerAddress = "";
  let customerPin = "";
  try {
    if (profileStr) {
      const pr = JSON.parse(profileStr);
      customerName = pr?.Name || "";
      customerAddress = pr?.Address || "";
      customerPin = pr?.PinCode || "";
    }
  } catch (e) {}
  const order = {
    orderId,
    items: (items || []).map((i) => ({
      productName: i?.ProductName || i?.name || `Item`,
      price: parseFloat(i?.Price ?? i?.price) || 0,
      quantity: Number(i?.Quantity ?? i?.quantity) || 1,
      id: i?.Id ?? i?.id,
    })),
    total: parseFloat(total) || 0,
    walletBalanceAfter: walletBalanceAfter || 0,
    date,
    time: new Date().toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }),
    customer: { name: customerName, address: customerAddress, pinCode: customerPin, mobile: mobileNo },
    status: "placed",
    createdAt: new Date().toISOString(),
  };
  saveOrder(order);
  return order;
};

export { sanitize };